import React from 'react';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '../../constants';

const LoginDevicesList = ({ loginDevices }) => {
  return (
    <div>
      <table className="table">
        <thead>
          <tr>
            <th>UID</th>
            <th>Email</th>
            <th>Created</th>
            <th>Validated</th>
            <th>Verification Code</th>
          </tr>
        </thead>
        <tbody>
          {loginDevices.length > 0 ? (
            loginDevices.map((item) => (
              <tr key={item.uid}>
                <td>{item.uid}</td>
                <td>{item.email}</td>
                <td>{moment(item.created).format(DATE_TIME_FORMAT)}</td>
                <td>{item.is_validated ? 'Yes' : 'No'}</td>
                <td>{item.verification_code ? item.verification_code : '-'}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td>No login devices for this user yet</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default LoginDevicesList;
